import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1";
const audioConverter = {
  toPm: {
    types: [Node_Type.AUDIO],
    // @ts-ignore $TSFixMe
    convert: (node) => ({
      type: Node_Type.AUDIO,
      attrs: {
        ...node.audioData,
        id: node.id
      }
    })
  },
  fromPm: {
    types: [Node_Type.AUDIO],
    convert: (node) => {
      const { id, ...data } = node.attrs || {};
      return {
        type: Node_Type.AUDIO,
        id,
        nodes: [],
        audioData: {
          ...data,
          disableDownload: data.disableDownload || void 0,
          name: data.name || void 0,
          authorName: data.authorName || void 0
        }
      };
    }
  }
};
export {
  audioConverter
};
//# sourceMappingURL=audio-converter.js.map
